import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';
import { LEAVE_TYPE_LABELS } from '../../../utils/leaveBalance';

/**
 * Texts of İzin Yönetimi (`leaves.*`). Leave types are stored as keys
 * (yillik, mazeret, ...); `typeLabel` shows them in the selected language.
 * Excel files and the response e-mail keep the Turkish labels.
 */
const useLeaveText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`leaves.${key}`, vars), [t]);
  const typeLabel = useCallback(
    (key) => (LEAVE_TYPE_LABELS[key] ? t(`leaves.types.${key}`) : key || '-'),
    [t]
  );
  /** Firestore Timestamp / Date / ISO string → short local date ("-" when empty). */
  const formatDate = useCallback((value, options) => {
    if (!value) return '-';
    const date = value.toDate ? value.toDate() : new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleDateString(locale, options);
  }, [locale]);
  /** Day counts can be halves (Saturday = 0.5). */
  const formatNumber = useCallback(
    (value) => (Number(value) || 0).toLocaleString(locale, { maximumFractionDigits: 2 }),
    [locale]
  );
  /** "3 gün" / "0,5 gün" (plural by count, number in the local format). */
  const days = useCallback((value) => {
    const count = Number(value) || 0;
    return t('leaves.common.days', { count, days: formatNumber(count) });
  }, [t, formatNumber]);
  return { t, language, locale, label, typeLabel, formatDate, formatNumber, days };
};

export default useLeaveText;
